var map = {
	"./apin/locales/en.json": 30778,
	"./apin/locales/pt.json": 91295,
	"./cadaval/locales/en.json": 19460,
	"./cadaval/locales/pt.json": 66840,
	"./fcolmeiasememoria/locales/en.json": 38593,
	"./fcolmeiasememoria/locales/pt.json": 71640,
	"./oaz/locales/en.json": 55048,
	"./oaz/locales/pt.json": 77492,
	"./oeiraseu/locales/en.json": 71151,
	"./oeiraseu/locales/pt.json": 82285,
	"./proenca/locales/en.json": 45353,
	"./proenca/locales/pt.json": 63509,
	"./rgrande/locales/en.json": 15856,
	"./rgrande/locales/pt.json": 46170,
	"./rnps/locales/en.json": 41047,
	"./rnps/locales/pt.json": 53287,
	"./vcambra/locales/en.json": 94022,
	"./vcambra/locales/pt.json": 86477,
	"src/configuration/platforms/apin/locales/en.json": 30778,
	"src/configuration/platforms/apin/locales/pt.json": 91295,
	"src/configuration/platforms/cadaval/locales/en.json": 19460,
	"src/configuration/platforms/cadaval/locales/pt.json": 66840,
	"src/configuration/platforms/fcolmeiasememoria/locales/en.json": 38593,
	"src/configuration/platforms/fcolmeiasememoria/locales/pt.json": 71640,
	"src/configuration/platforms/oaz/locales/en.json": 55048,
	"src/configuration/platforms/oaz/locales/pt.json": 77492,
	"src/configuration/platforms/oeiraseu/locales/en.json": 71151,
	"src/configuration/platforms/oeiraseu/locales/pt.json": 82285,
	"src/configuration/platforms/proenca/locales/en.json": 45353,
	"src/configuration/platforms/proenca/locales/pt.json": 63509,
	"src/configuration/platforms/rgrande/locales/en.json": 15856,
	"src/configuration/platforms/rgrande/locales/pt.json": 46170,
	"src/configuration/platforms/rnps/locales/en.json": 41047,
	"src/configuration/platforms/rnps/locales/pt.json": 53287,
	"src/configuration/platforms/vcambra/locales/en.json": 94022,
	"src/configuration/platforms/vcambra/locales/pt.json": 86477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85522;